import base from "./base.service";
import { jwtDecode } from "jwt-decode";

const authorizedInstance = base.service(true);
const unauthorizedInstance = base.service(false);

export const register = (request) => {
  return authorizedInstance.post("/Account/register", request);
};

export const authenticate = async (request) => {
  return await unauthorizedInstance.post("/Account/auhenticate", request);
};

export const getAllUsers = async (request) => {
  return await authorizedInstance.get("/Account/get-all");
};
export const getCurrentAccount = () => {
  return authorizedInstance.get("/Account/get-user");
};

export const getRole = () => {
  const token = sessionStorage.getItem("token");
  if (token) {
    const decodedToken = jwtDecode(token);
    const userRole = decodedToken.role;
    return userRole;
  } else {
    return "noRole";
  }
};
export const isTokenExpired = () => {
  const token = sessionStorage.getItem("token");
  if (!token) return true;
  const { exp } = jwtDecode(token);
  return Date.now() >= exp * 1000;
};
export const isLoggedIn = () => {
  const token = sessionStorage.getItem("token");
  const role = getRole();
  if (!token) return false;
  return role.includes("Admin");
};

export default {
  authenticate,
  register,
  getCurrentAccount,
  getRole,
  isLoggedIn,
  isTokenExpired,
};
